jQuery(function ($) {

	accordionInit();
	dashboardInit();
	initTooltip();
	formsInit();
	initMasks();
	tabsInit();
	mobileNavigation();
	initDatepicker();
	initSelect2('select','form#edit-registration select, .dataTables_wrapper select, [data-autocosts="on"], .no-select2');
	initSelect2Autocomplete('[data-autocosts="on"]');
	initPlyr();
	initRangeSlider();
	initStarRating();
	initobjView();
	debugInit();
	fullscreenInit();
	toggleSidebar();
	closeSidebar();
	calculateDateDifferenceInDays();

	function mobileNavigation() {
		$('#mobile-top i').on('click', function () {
			$('#navigation').toggleClass('active');

			var sidebar = $('.user-sidebar');
			sidebar.addClass('closed')

			sidebar.attr('data-status', 'closed');
		});
		$('#close-navigation').on('click', function () {
			$('#mobile-top i').trigger('click');
		});
	}

	function initRangeSlider() {
		$('.range-slider').each(function () {
			var _showValue = $(this).parent().find(".range-value")[0];
			$(this).rangeslider({
				polyfill: false,
				onSlide: function (p, v) {
					$(_showValue).html(v + '%');
				},
			});
		});
	}

	function initStarRating() {
		$('.star-rating').each(function () {
			$(this).rating({
				starCaptions: {
					0: 'Not Rated',
					1: 'Poor',
					2: 'So-So',
					3: 'OK',
					4: 'Good',
					5: 'Exceptional!'

				},
				emptyStar: '<i class="fas fa-star"></i>',
				filledStar: '<i class="fas fa-star"></i>'
			});
		});


	}

	function accordionInit() {
		$('.accordions').find('.accordion-toggle').click(function () {
			var $elem = $(this);
			$('.accordions .accordion-toggle').removeClass('active');
			//Expand or collapse this panel
			$(this).next().slideToggle('fast', function () {
				if ($elem.next().is(':visible')) {
					$elem.addClass('active');
				} else {
					$elem.removeClass('active');
				}
			});
			//Hide the other panels
			$(".accordion-content").not($(this).next()).slideUp('fast');
		});
	}

	function dashboardInit() {
		if ($(window).width() < 996) {
			$('.enrollment-step .collapse').removeClass('show');
		}
	}

	function initDatepicker() {
		$('.date-range, .date').datepicker({
			format: 'yyyy-mm-dd',
			endDate: '0d',
			keepEmptyValues: true,
			autoclose: true,
			templates: {
				leftArrow: '<i class="fal fa-long-arrow-left"></i>',
				rightArrow: '<i class="fal fa-long-arrow-right"></i>'
			}
		});

		// Using font-awesome 5 icons
		$.extend(true, $.fn.datetimepicker.defaults, {
			icons: {
				time: 'far fa-clock',
				date: 'far fa-calendar',
				up: 'fas fa-arrow-up',
				down: 'fas fa-arrow-down',
				previous: 'fas fa-chevron-left',
				next: 'fas fa-chevron-right',
				today: 'fas fa-calendar-check',
				clear: 'far fa-trash-alt',
				close: 'far fa-times-circle'
			}
		});

		// $('.date-time').datetimepicker({
		// 	showTodayButton:true,
		//
		// });
		$('.date-time').each(function () {
			var _defaultDate = $(this).val();

			$(this).datetimepicker({
				showTodayButton: true,
				format:'Y-MM-DD HH:mm:ss',
				date: moment(_defaultDate),
			});

		});

		$('.date-future').datepicker({
			format: 'yyyy-mm-dd',
			endDate: Infinity,
			keepEmptyValues: true,
			autoclose: true,
			templates: {
				leftArrow: '<i class="fal fa-long-arrow-left"></i>',
				rightArrow: '<i class="fal fa-long-arrow-right"></i>'
			}
		});

		$('.date-range input').each(function () {
			$(this).datepicker('clearDates');
		});
	}

	function formsInit() {
		$(document).on('submit', 'form', function () {
			$.LoadingOverlay('show');
		});
	}

	function initMasks(nodezero) {
		var selector = nodezero ? nodezero + ' :input' : ':input';
		$(selector).inputmask();
	}

	function tabsInit() {
		// Persist tab selection state...
		if (location.hash.substr(0, 2) == "#!") {
			$("a[href='#" + location.hash.substr(2) + "']").tab("show");
		}
		$("a[data-toggle='tab']").on("shown.bs.tab", function (e) {
			var hash = $(e.target).attr("href");
			// Set tab position in url...
			if (hash.substr(0, 1) == "#") {
				location.replace("#!" + hash.substr(1));
			}

			$('#tabPos').val('#!' + hash.substr(1));
		});
	}

	function debugInit() {
		$('#debug-info .toggle').on('click', function () {
			$(this).parent().toggleClass('active');
			$(this).parent().find('.wrapper').slideToggle();
		});
	}

	function fullscreenInit() {
		$('[data-fullscreen]').on('click', function () {
			var target = $(this).data('fullscreen').toString();

			if (screenfull.enabled) {
				screenfull.request($('#' + target)[0]);
			}
		});
		if (screenfull.enabled) {
			screenfull.on('change', function () {
				console.log('Am I fullscreen?', screenfull.isFullscreen ? 'Yes' : 'No');
				$('body').toggleClass('fullscreen');
			});
		}
	}

	function initPlyr() {
		const players = Plyr.setup('.plyr-player');
	}

	function initobjView() {

		$('.addObjView').each(function () {
			var dueid = '_' + Math.random().toString(36).substr(2, 9);
			$(this).attr('data-dueid', dueid);
			var _obj_ = $('[data-dueid="' + dueid + '"]').val();
			if (_obj_) {
				$(this).before('<a href="javascript:;" onclick="mDialog(\'/dialog?data=_obj_' + _obj_ + '&view=array2dtable\', \'Object Debug View\', null, null, \'large\');"><i class="fal fa-bug"></i></a>');
			}
		});

	}

	function logoAnimeInit() {
		anime.timeline({loop: false})
			.add({
				targets: '.logo svg *',
				opacity: 1,
				easing: "easeInOutQuad",
				duration: 2250,
				delay: function (el, i) {
					return 150 * (i + 1);
				}
			});
	}

});

// ---------------------------------------------------------------------------------

window.formatPhoneNumber = function (phone) {
	var number = phone.replace(/\D/g, '');
	return number.replace(/(\d\d\d)(\d\d\d)(\d\d\d\d)/, "($1) $2-$3");
};

window.initTooltip = function (nodezero) {

	var selector = nodezero ? nodezero + ' [data-toggle="tooltip"]' : '[data-toggle="tooltip"]';

	$(selector).tooltipster({
		theme: ['tooltipster-borderless', 'tooltipster-borderless-rinnai'],
		plugins: ['follower'],
		maxWidth: 250,
		interactive: true
	});
};

window.refreshStatesonCountryChange = function (configKey, target) {

	$.ajax({
		url: "/api/v1/config/" + configKey,
		success: function (data) {
			data.results = [];
			data.results.push('', '')
			$.each(data.data, function (key, value) {
				data.results.push({'id': key, 'text': value});
			});

			initSelect2(target, '', data.results);
		}
	});

};

window.initSelect2 = function (_match, _avoid, _data, _ajax) {

	// console.log(arguments);
	//wrap 'select' elements with wrapper
	// if(_match=='select'){
	// 	$(_match).wrap("<div class='select-container'></div>");
	// }

	$(_match).not(_avoid).each(function () {

		var _selectControl = $(this);
		var _placeholder = _selectControl.data('placeholder') ? _selectControl.data('placeholder') : "Select Your Option";
		var _allowClear = _selectControl.data('allowclear') !== undefined ? _selectControl.data('allowclear') : true;
		var _options = {
			placeholder: _placeholder,
			allowClear: _allowClear,
			width: '100%',
			// sorter: function(data) {
			// 	var withoutPlaceholders = data.filter(function(item) {
			// 		return item.text != 'Unassigned' && item.text != 'Select';
			// 	});
			// 	var unassigned = data.filter(function(item) {
			// 		return item.text == 'Unassigned';
			// 	})
			// 	var select = data.filter(function(item) {
			// 		return item.text == 'Select';
			// 	})
			//
			// 	var items = withoutPlaceholders.sort(function (a, b) {
			// 		var enrollmentStepsA = (a.text == 'New Application' || a.text == 'PRO Consultation' || a.text == 'RSM Training Review' || a.text == 'Electronic Signatures' || a.text == 'PRO OnBoarding');
			// 		var enrollmentStepsB = (b.text == 'New Application' || b.text == 'PRO Consultation' || b.text == 'RSM Training Review' || b.text == 'Electronic Signatures' || b.text == 'PRO OnBoarding');
			// 		if (!enrollmentStepsA) {
			// 			if (a.text > b.text) {
			// 				return 1;
			// 			}
			//
			// 			if (a.text < b.text) {
			// 				return -1;
			// 			}
			//
			// 			return 0;
			// 		}
			// 	});
			//
			// 	if (unassigned.length) {
			// 		items.unshift(unassigned[0]);
			// 	}
			//
			// 	if (select.length) {
			// 		items.unshift(select[0]);
			// 	}
			//
			// 	return items;
			// }
		};

		if (_data) {
			_options.data = _data;
			_selectControl.empty();
		}

		if (_ajax) {
			_options.ajax = _ajax;
		}

		_selectControl.select2(_options);
	});

};

window.initSelect2Autocomplete = function (_match) {
	$(_match).each(function () {
		var _selectControl = $(this);
		var _autocotype = _selectControl.data('autocotype');
		var _autocowhere = _selectControl.data('autocowhere');
		var _autocosrchcols = _selectControl.data('autocosrchcols');
		var _autocoidtext = _selectControl.data('autocoidtext');
		var _autocoinival = _selectControl.data('autocoinival');
		var _autocominlen = _selectControl.data('autocominlen');
		var _placeholder = _selectControl.data('placeholder') ? _selectControl.data('placeholder') : "Start Typing...";
		var _allowClear = _selectControl.data('allowclear') !== undefined ? _selectControl.data('allowclear') : true;

		if (typeof _autocoinival !== 'undefined') {
			var _IdText = _autocoidtext.split(',');
			$.ajax({
				url: '/api/v1/' + _autocotype + '/' + _autocowhere + '|where::' + _IdText[0] + '::=::' + _autocoinival + '?pagesize=none&columns=' + _autocoidtext,
				success: function (result) {
					var _r = result.data[0];
					_selectControl.append($('<option>', {
						value: _r[_IdText[0]],
						text: _r[_IdText[1]] + (_r[_IdText[2]] ? ' (' + _r[_IdText[2]] + ')' : '')
					}));
				}
			});
		}

		_selectControl.select2({
			ajax: {
				delay: 1000,
				url: function url(params) {
					var _searchOnTerm = 'where::' + _autocosrchcols + '::like::%25' + params.term + '%25';
					var _orderOnTerm = _autocosrchcols ? _autocosrchcols + '::asc' : '';

					if (typeof params.term === 'undefined') {
						return '/api/v1/' + _autocotype + '/' + _autocowhere + '/' + _orderOnTerm + '?pagesize=none&columns=' + _autocoidtext;
					} else {
						return '/api/v1/' + _autocotype + '/' + _autocowhere + '|' + _searchOnTerm + '/' + _orderOnTerm + '?pagesize=none&columns=' + _autocoidtext;
					}
				},
				dataType: 'json',
				data: function data(params) {
					var queryParameters = {};
					return queryParameters;
				},
				processResults: function processResults(data) {			// Tranforms the top-level key of the response object from 'items' to 'results'
					var _IdText = _autocoidtext.split(',');
					var foo = {};
					var items = [];
					if (data.data) {
						$.each(data.data, function (i, item) {
							if (!(item[_IdText[0]] in foo)) {
								items.push({
									id: item[_IdText[0]],
									text: item[_IdText[1]] + (item[_IdText[2]] ? ' (' + item[_IdText[2]] + ')' : '')
								});
								foo[item[_IdText[0]]] = item[_IdText[1]];
							}
						});
					}
					return {
						results: items
					};
				},
				cache: true
			},
			minimumInputLength: _autocominlen ? _autocominlen : 0,
			placeholder: _placeholder,
			allowClear: _allowClear,
			width: '100%'
		});

		if (typeof _autocoinival !== 'undefined') {
			_selectControl.val(_autocoinival).trigger('change');
		}
	});
};

window.formatDateStamp = function(dateString) {
	var date = new Date(dateString);
	var month = (date.getMonth() <= 9) ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
	var day =date.toUTCString().split(' ')[1];
	var hours = (date.getHours() <= 9) ? '0' + date.getHours() : date.getHours();
	var minutes = (date.getMinutes() <= 9) ? '0' + date.getMinutes() : date.getMinutes();
	var seconds = (date.getSeconds() <= 9) ? '0' + date.getSeconds() : date.getSeconds();
	return date.getFullYear() + '-' + month + '-' + day  + ' ' + hours + ':' + minutes + ':' + seconds;
};

window.formatDateStampWithoutTime = function(dateString) {
	if (dateString) {
		var date = new Date(dateString);
		date.toLocaleString('en-us', { timeZone : 'America/New_York'});
		var month = (date.getMonth() <= 9) ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
		var day = date.toUTCString().split(' ')[1];
		return date.getFullYear() + '-' + month + '-' + day;
	}

	return '';
};

window.buildApiUrl = function (_baseurl, _parms, _relem) {
	// console.log(arguments);

	var _url = _baseurl;

	var _slash = (_url.split('/').length == 5 && _url.substr(-1) != '/') ? true : false;
	$('.dtfilter').each(function (i, e) {

		var _val = '';

		if ($(this).prop('type') == 'radio') {
			if ($(this).prop('checked') && !$(this).is(_relem) && $(this).attr('name') != $(_relem).attr('name')) {
				_val = $(this).val();
			} else {
				if ($(this).is(_relem)) {
					_val = $(_relem).val();
				}
			}
		} else if( $(this).prop('type') == 'checkbox'){
            if( $(this).prop('checked') ){
                _val = $(this).val();
            }
		} else {
			_val = $(this).val();
		}

		if (_val && $(this).data('cond')) {
			_url = _url + (_slash ? '/' : '') +
				((i > 0 && !_slash) ? '|' : '') +
				$(this).data('cond') +
				_val +
				($(this).data('posval') ? $(this).data('posval') : '');
			_slash = false;
		}

	});

	var _slash = (_url.split('/').length == 6 && _url.substr(-1) != '/') ? true : false;
	$('.dtorder').each(function (i, e) {

		var _val = '';

		if ($(this).prop('type') == 'radio') {
			if ($(this).prop('checked') && !$(this).is(_relem) && $(this).attr('name') != $(_relem).attr('name')) {
				_val = $(this).val();
			} else {
				if ($(this).is(_relem)) {
					_val = $(_relem).val();
				}
			}
		} else {
			_val = $(this).val();
		}

		if (_val) {
			_url = _url + (_slash ? '/' : '') +
				((i > 0 && !_slash) ? '|' : '') +
				_val;
			_slash = false;
		}

	});

	if (!_relem) {
		$('.dtfilter[data-countme]').each(function () {
			var _e = this;
			var _t = $(_e).data('countme');

			if ($(_t).is(':visible')) {
				$.ajax({
					url: buildApiUrl(_baseurl, 'format=count', _e),
					success: function (result) {
						var _format = $(_e).data('countme-format');
						if (_format) {
							$(_t).text(numbro(result.data).format(_format));
						} else {
							$(_t).text(result.data);
						}
					}
				});
			}
		});
	}

	return _parms ? _url + '?' + _parms : _url;
};

//john youngman for csp
window.applyCSPFilter = function applyCSPFilter(params) {

	if(typeof(params)==='undefined'){
		params='';
	}
	var brandsList = $("input[name='FILTER_brands_serviced[]']:checked").map(function () {
		return this.value;
	}).get();

	var partsList = $("input[name='FILTER_parts_stocked[]']:checked").map(function () {
		return this.value;
	}).get();

	var _extra = 'addfx=csps';
	if (brandsList !== '') {
		_extra += '&brands_serviced=' + brandsList;
	}
	if (partsList !== '') {
		_extra += "&parts_stocked=" + partsList;
	}

	var postal = $("#filterPostal").val();
	var prox = $("#filterProximity").val();
	if(postal!==''){
		_extra+= "&zip=" + postal;
	}
	if(prox!=='' && postal!==''){
		_extra+="&proximity=" + prox;
	}
	_extra+=params;



	return buildApiUrl('/api/v1/list/csps', _extra,false);

}

window.newRow = function (tblSelector, focusat, at = "last", pos = "after", vals) {

	// console.log(arguments);

	var trLength = $(tblSelector + " > tbody > tr").length;
	var rowNUM = trLength ? trLength : 0;
	var rowHTML = $(tblSelector + " tr#rowID_N").html().replace(/{N}/g, rowNUM);

	if (trLength) {
		if (pos == "after") {
			$(tblSelector + " > tbody > tr:" + at).after('<tr id="rowID_' + rowNUM + '">' + rowHTML + '</tr>');
		} else {
			$(tblSelector + " > tbody > tr:" + at).before('<tr id="rowID_' + rowNUM + '">' + rowHTML + '</tr>');
		}
	} else {
		$(tblSelector + " > tbody").append('<tr id="rowID_' + rowNUM + '">' + rowHTML + '</tr>');
	}
	$(tblSelector + " > tbody > tr#rowID_" + rowNUM + " :input:visible:disabled:not([readonly])").prop("disabled", false);

	if (typeof vals != "undefined") {
		var res = vals.split("::");
		$.each(res, function (k, v) {
			$(tblSelector + " > tbody > tr#rowID_" + rowNUM + " input:eq(" + k + ")").val(v);
		});
	}

	initSelect2(tblSelector + " > tbody > tr#rowID_" + rowNUM + " .no-select2");

	if (focusat !== null) {
		var _e2focus = $(tblSelector + " > tbody > tr#rowID_" + rowNUM + " :input:visible:enabled:not([readonly]):eq(" + focusat + ")");
		if (_e2focus.data('select2Id') !== undefined) {
			$('#' + _e2focus.data('select2Id')).select2('open');
		} else {
			_e2focus.focus();
		}
	}

	return rowNUM;
};

window.delRow = function (tblSelector, rid) {
	var isInputDisable = $(tblSelector + " > tbody > tr#" + rid + " :input:disabled").length;
	if (isInputDisable > 0) {
		$(tblSelector + " > tbody > tr#" + rid + " :input").prop("disabled", false);
		$(tblSelector + " > tbody > tr#" + rid + " > td").css("text-decoration", "");
	} else {
		$(tblSelector + " > tbody > tr#" + rid + " :input").prop("disabled", true);
		$(tblSelector + " > tbody > tr#" + rid + " > td").css("text-decoration", "line-through");
	}
	$(tblSelector + " > tbody > tr#" + rid + " .actlnks").toggleClass('d-none');
};

window.mDialog = function (url, title, onload, onclose, size) {
	const labels = [];
	labels['_SEARCH_'] = 'Search';
	labels['_MSG_WAIT_SM_'] = '<div class="d-block mx-auto spinner-grow text-primary" role="status"><span class="sr-only">Loading...</span></div>';
	labels['_IFRAMES_NOT_SUPPORTED_'] = 'Your browser does not support iframes.';
	labels['_ERROR_'] = 'Error';
	labels['_SUBMIT_ERROR_'] = 'The submitted request did not return the expected result';
	labels['_CLOSE_'] = 'Close';

	var dialog = bootbox.alert({
		title: title,
		size: size,
		message: labels['_MSG_WAIT_SM_']
	});

	if (url.substring(0, 5) === 'http:' || url.substring(0, 6) === 'https:') {
		dialog.find('.bootbox-body').html('<iframe src="' + url + '" frameborder="0"><p>' + labels['_IFRAMES_NOT_SUPPORTED_'] + '</p></iframe>');
	} else if (url.substring(0, 5) === 'text:') {
		dialog.find('.bootbox-body').html(url.substring(5));
	} else if (url.substring(0, 5) === 'none:') {
		//
	} else if (url.substring(0, 1) === '#') {
		dialog.find('.bootbox-body').html($(url).html());
	} else {
		dialog.find('.bootbox-body').load(url, null, function (response, status, xhr) {
			if (status === 'error') {
				dialog.find('.bootbox-body').html(`
											<p>${labels['_SUBMIT_ERROR_']}</p>
											<p class="text-danger font-weight-bold">${labels['_ERROR_']} ${xhr.status}  ${xhr.statusText}</p>
										`);
			} else {
				initDataTables('.bootbox-body');
				initTooltip('.bootbox-body');
				if (onload) onload();
			}
		});
	}
};

window.initDataTables = function (nodezero) {

	var selector = nodezero ? nodezero + ' .dataTable' : '.dataTable';

	$(selector).each(function (idx) {
		_dtblObject = $(this).DataTable({
			pageLength: 10,
			responsive: true,
			// dom: '<"html5buttons"B>lTfgitp',
			dom: '<"top"lf>rt<"bottom"ip>',
			buttons: [
				// {extend: 'copy'},
				// {extend: 'csv'},
				// {extend: 'excel', title: 'Dealer Enrollment Portal', filename: 'Dealer_Enrollment_Export'},
				// {extend: 'pdf', orientation: 'landscape', title: 'Dealer Enrollment Portal', filename: 'Dealer_Enrollment_Export'},
				// {extend: 'print',
				//     customize: function (win){
				//         $(win.document.body).addClass('white-bg');
				//         $(win.document.body).css('font-size', '10px');
				//         $(win.document.body).find('table')
				//         .addClass('compact')
				//         .css('font-size', 'inherit');
				//     }
				// }
			],
			oSearch: {'sSearch': $(this).data('dtqry') ? $(this).data('dtqry') : ''},
			initComplete: function (settings, json) {
				//new SimpleBar($(this).find('tbody')[0]);
			},
			drawCallback: function (settings) {
				initTooltip();
			}
		});

		// Add column search inputs...
		$(this).find("thead tr th").each(function () {
			if ($(this).data("enablesrch")) {
				var title = $(this).text();
				$(this).html('<input type="text" class="form-control input-sm" placeholder="' + title + '" title="' + title + '" style="' + $(this).data("srchstyle") + '" />');
			}
		});

		_dtblObject.on('search.dt', function () {

		});

		// Apply the search...
		_dtblObject.columns().every(function () {
			var that = this;
			$('input', this.header()).on('keyup change click', function (event) {
				if (that.search() !== this.value) {
					that.search(this.value).draw();
				}
				event.stopPropagation();
			});
		});
	});    // end each()...

};
// ---------------------------------------------------------------------------------


jQuery.fn.extend({
	animateCss: function (animationName, callback) {
		var animationEnd = (function (el) {
			var animations = {
				animation: 'animationend',
				OAnimation: 'oAnimationEnd',
				MozAnimation: 'mozAnimationEnd',
				WebkitAnimation: 'webkitAnimationEnd',
			};

			for (var t in animations) {
				if (el.style[t] !== undefined) {
					return animations[t];
				}
			}
		})(document.createElement('div'));

		this.addClass('animated ' + animationName).one(animationEnd, function () {
			jQuery(this).removeClass('animated ' + animationName);

			if (typeof callback === 'function') callback();
		});

		return this;
	}
});

jQuery.fn.fadeOutAndRemove = function (speed) {
	$(this).fadeOut(speed, function () {
		$(this).remove();
	});
};

var toggleSidebar = function() {
	$('.toggle-sidebar').on('click', function(e) {
		var sidebar = $('.user-sidebar');
		var status = sidebar.attr('data-status');

		if (status === 'open') {
			sidebar.addClass('closed').removeClass('open');

			sidebar.attr('data-status', 'closed');
		} else {
			sidebar.addClass('open').removeClass('closed');
			sidebar.attr('data-status', 'open');

			$('#navigation').removeClass('active');
		}
	});
}

var closeSidebar = function() {
	$('.close-sidebar').on('click', function(e) {
		$('.user-sidebar').addClass('closed');
	});
}

window.calculateDateDifferenceInDays = function(from, to) {
	if (from && to) {
		return Math.floor((new Date(to) - new Date(from)) / (1000 * 60 * 60 * 24));
	}

	return 0;
}

/*
Chart.elements.Rectangle.prototype.draw = function() {
    var ctx = this._chart.ctx;
    var vm = this._view;
    var left, right, top, bottom, signX, signY, borderSkipped, radius;
    var borderWidth = vm.borderWidth;
    // Set Radius Here
    // If radius is large enough to cause drawing errors a max radius is imposed
    var cornerRadius = 10;

    if (!vm.horizontal) {
        // bar
        left = vm.x - vm.width / 2;
        right = vm.x + vm.width / 2;
        top = vm.y;
        bottom = vm.base;
        signX = 1;
        signY = bottom > top? 1: -1;
        borderSkipped = vm.borderSkipped || 'bottom';
    } else {
        // horizontal bar
        left = vm.base;
        right = vm.x;
        top = vm.y - vm.height / 2;
        bottom = vm.y + vm.height / 2;
        signX = right > left? 1: -1;
        signY = 1;
        borderSkipped = vm.borderSkipped || 'left';
    }

    // Canvas doesn't allow us to stroke inside the width so we can
    // adjust the sizes to fit if we're setting a stroke on the line
    if (borderWidth) {
        // borderWidth shold be less than bar width and bar height.
        var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
        borderWidth = borderWidth > barSize? barSize: borderWidth;
        var halfStroke = borderWidth / 2;
        // Adjust borderWidth when bar top position is near vm.base(zero).
        var borderLeft = left + (borderSkipped !== 'left'? halfStroke * signX: 0);
        var borderRight = right + (borderSkipped !== 'right'? -halfStroke * signX: 0);
        var borderTop = top + (borderSkipped !== 'top'? halfStroke * signY: 0);
        var borderBottom = bottom + (borderSkipped !== 'bottom'? -halfStroke * signY: 0);
        // not become a vertical line?
        if (borderLeft !== borderRight) {
            top = borderTop;
            bottom = borderBottom;
        }
        // not become a horizontal line?
        if (borderTop !== borderBottom) {
            left = borderLeft;
            right = borderRight;
        }
    }

    ctx.beginPath();
    ctx.fillStyle = vm.backgroundColor;
    ctx.strokeStyle = vm.borderColor;
    ctx.lineWidth = borderWidth;

    // Corner points, from bottom-left to bottom-right clockwise
    // | 1 2 |
    // | 0 3 |
    var corners = [
        [left, bottom],
        [left, top],
        [right, top],
        [right, bottom]
    ];

    // Find first (starting) corner with fallback to 'bottom'
    var borders = ['bottom', 'left', 'top', 'right'];
    var startCorner = borders.indexOf(borderSkipped, 0);
    if (startCorner === -1) {
        startCorner = 0;
    }

    function cornerAt(index) {
        return corners[(startCorner + index) % 4];
    }

    // Draw rectangle from 'startCorner'
    var corner = cornerAt(0);
    ctx.moveTo(corner[0], corner[1]);

    for (var i = 1; i < 4; i++) {
        corner = cornerAt(i);
        nextCornerId = i+1;
        if(nextCornerId == 4){
            nextCornerId = 0
        }

        nextCorner = cornerAt(nextCornerId);

        width = corners[2][0] - corners[1][0];
        height = corners[0][1] - corners[1][1];
        x = corners[1][0];
        y = corners[1][1];

        var radius = cornerRadius;

        // Fix radius being too large
        if(radius > height/2){
            radius = height/2;
        }if(radius > width/2){
            radius = width/2;
        }



				var lastVisible = 0;
				for(var findLast=0, findLastTo=this._chart.data.datasets.length;findLast<findLastTo;findLast++) {
        	if (!this._chart.getDatasetMeta(findLast).hidden) {
          	lastVisible =findLast;
          }
        }
				var rounded = this._datasetIndex  === lastVisible;

        if (rounded) {
          ctx.moveTo(x + radius, y);
          ctx.lineTo(x + width - radius, y);
          ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
          ctx.lineTo(x + width, y + height);
          ctx.lineTo(x, y + height);
          ctx.lineTo(x, y + radius);
          ctx.quadraticCurveTo(x, y, x + radius, y);
        } else {
          ctx.moveTo(x, y);
          ctx.lineTo(x + width, y);
          ctx.lineTo(x + width, y + height );
          ctx.lineTo(x , y + height);
          ctx.lineTo(x, y );
        }

    }

    ctx.fill();
    if (borderWidth) {
        ctx.stroke();
    }
};
*/
